export default __webpack_public_path__ + "static/media/Terminus.ff6d43e3.jpg";